// Event types
const ADD_DEPENDENT = 'ADD_DEPENDENT';
const ADD_DEPENDENTS = 'ADD_DEPENDENT(S)';
const ADOPTION = 'ADOPTION';
const BIRTH = 'BIRTH';
const BIRTH_ADOPTION = 'BIRTH_ADOPTION';
const BIRTH_OR_ADOPTION = 'BIRTH_OR_ADOPTION';
const CHANGE_IN_ADDRESS = 'CHANGE_IN_ADDRESS';
const CHANGE_IN_ADDRESS_FUTURE = 'CHANGE_IN_ADDRESS_FUTURE';
const CHANGE_IN_ADDRESS_WITHIN_STATE = 'CHANGE_IN_ADDRESS_WITHIN_STATE';
const CHANGE_IN_AI_AN_STATUS = 'CHANGE_IN_AMERICAN INDIAN / ALASKA NATIVE STATUS';
const CHANGE_IN_CITIZENSHIP = 'CHANGE_IN_CITIZENSHIP';
const CHANGE_IN_HOUSEHOLD_SIZE = 'CHANGE_IN_HOUSEHOLD_SIZE';
const CHANGE_IN_INCARCERATION = 'CHANGE_IN_INCARCERATION';
const CHANGE_IN_INCOME = 'CHANGE_IN_INCOME';
const CHANGE_IN_LEGAL_PRESENCE = 'CHANGE_IN_LEGAL_PRESENCE';
const CHANGE_IN_TRIBE_STATUS = 'CHANGE_IN_TRIBE_STATUS';
const CHILD_AGED_OUT_FROM_OLD_APPLICATION = 'CHILD_AGED_OUT_FROM_OLD_APPLICATION';
const DEATH = 'DEATH';
const DEATH_OF_PTF_OR_SUBSCRIBER = 'DEATH_OF_PTF_OR_SUBSCRIBER';
const DIVORCE = 'DIVORCE';
const DIVORCE_OR_ANULLMENT = 'DIVORCE_OR_ANULLMENT';
const EMPLOYER_SPONSORED_COVERAGE_AFFORDABLE = 'EMPLOYER_SPONSORED_COVERAGE_AFFORDABLE';
const EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE = 'EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE';
const ERROR_ASSISTER_BROKER = 'ERROR_ASSISTER_BROKER';
const ERROR_DUE_TO_ASSISTER_OR_BROKER = 'ERROR_DUE_TO_ASSISTER_OR_BROKER';
const ERROR_DUE_TO_EXCHANGE = 'ERROR_DUE_TO_EXCHANGE';
const ERROR_EXCHANGE = 'ERROR_EXCHANGE';
const ERROR_HEALTH_PLAN_VIOLATION = 'ERROR_HEALTH_PLAN_VIOLATION';
const ERROR_PLAN_BENEFIT_DISPLAY = 'ERROR_PLAN_BENEFIT_DISPLAY';
const ERROR_PLAN_OR_BENEFIT_DISPLAY = 'ERROR_PLAN_OR_BENEFIT_DISPLAY';
const EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL = 'EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL';
const EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER = 'EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER';
const EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR = 'EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN/PROGRAM_ERROR';
const EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG = 'EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG';
const EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR = 'EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR';
const EXEMPTION_CANCELLED = 'EXEMPTION_CANCELLED';
const FUTURE_LOSS_OF_MEC = 'FUTURE_LOSS_OF_MEC';
const GAIN_CITIZENSHIP = 'GAIN_CITIZENSHIP';
const GAIN_COURT_APPOINTED_DEPENDENT = 'GAIN_COURT_APPOINTED_DEPENDENT';
const GAIN_IN_TRIBE_STATUS = 'GAIN_IN_TRIBE_STATUS';
const GAIN_LPR = 'GAIN_LPR';
const GAIN_OF_AI_AN = 'GAIN_OF_AI_AN';
const GAIN_OF_AMERICAN_INDIAN_STATUS = 'GAIN_OF_AMERICAN_INDIAN_STATUS';
const HRA = 'HRA';
const HRA_FUTURE = 'HRA_FUTURE';
const ICHRA_SEP = 'ICHRA_SEP';
const ICHRA_SEP_FUTURE = 'ICHRA_SEP_FUTURE';
const INCARCERATION = 'INCARCERATION';
const INCOME_CHANGE_CSR = 'INCOME_CHANGE_CSR';
const LEGAL_SEPARATION = 'LEGAL_SEPARATION';
const LOSE_COVERAGE_NON_PAYMENT = 'LOSE_COVERAGE_NON_PAYMENT';
const LOSE_COVERAGE_NON_PAYMENT_TYPE4 = 'LOSE_COVERAGE_NON_PAYMENT_TYPE4';
const LOSE_EMPLOYER_COVERAGE = 'LOSE_EMPLOYER_COVERAGE';
const LOSE_EMPLOYER_COVERAGE_TYPE4 = 'LOSE_EMPLOYER_COVERAGE_TYPE4';
const LOSE_OTHER_PUBLIC_MEC = 'LOSE_OTHER_PUBLIC_MEC';
const LOSE_OTHER_PUBLIC_MEC_TYPE4 = 'LOSE_OTHER_PUBLIC_MEC_TYPE4';
const LOSS_OF_AIAN = 'LOSS_OF_AIAN';
const LOSS_OF_COVERAGE_THROUGH_EMPLOYER = 'LOSS_OF_COVERAGE_THROUGH_EMPLOYER';
const LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE = 'LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE';
const LOSS_OF_MEC = 'LOSS_OF_MEC';
const LOSS_OF_MEC_FUTURE = 'LOSS_OF_MEC_FUTURE';
const LOSS_OF_MEDICAID = 'LOSS_OF_MEDICAID';
const LOSS_OF_MEDICAID_FUTURE = 'LOSS_OF_MEDICAID_FUTURE';
const LOST_OTHER_MIN_ESSENTIAL_COVERAGE = 'LOST_OTHER_MIN_ESSENTIAL_COVERAGE';
const LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE = 'LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE';
const MARRIAGE = 'MARRIAGE';
const MOVED_INTO_STATE = 'MOVED_INTO_STATE';
const MOVED_INTO_STATE_FUTURE = 'MOVED_INTO_STATE_FUTURE';
const NEWLY_ELIG_FOR_APTC = 'NEWLY_ELIG_FOR_APTC';
const NOT_INCARCERATED = 'NOT_INCARCERATED';
const OTHER_EXCEPTIONAL_CIRCUMSTANCES = 'OTHER_EXCEPTIONAL_CIRCUMSTANCES';
const PRIMARY_GAIN_OF_MEC = 'PRIMARY_GAIN_OF_MEC';
const PRIMARY_GAIN_OF_MEC_FUTURE = 'PRIMARY_GAIN_OF_MEC_FUTURE';
const QSEHRA_SEP = 'QSEHRA_SEP';
const QSEHRA_SEP_FUTURE = 'QSEHRA_SEP_FUTURE';
const REMOVE_DEPENDENT = 'REMOVE_DEPENDENT';
const SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT = 'SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT';
export const UNSUPPORTED_EVENT = 'UNSUPPORTED_EVENT';

// Category types

const ADDRESS_PROOF = 'ADDRESS_PROOF';
const CURRENT_ADDRESS_PROOF = 'CURRENT_ADDRESS_PROOF';
const DOC_INDICATING_ADD_REMOVE_OF_DEP = 'DOC_INDICATING_ADD_REMOVE_OF_DEP';
const DOC_INDICATING_EXCEPTIONS = 'DOC_INDICATING_EXCEPTIONS';
const DOC_INDICATING_PROOF_OF_DEATH = 'DOC_INDICATING_PROOF_OF_DEATH';
const DOC_PROVING_EVENT = 'DOC_PROVING_EVENT';
const EXCHANGE_CONFIRMATION_OF_APTC = 'EXCHANGE_CONFIRMATION_OF_APTC';
const IDENTIFICATION = 'IDENTIFICATION';
const PROOF_ADOPTION = 'PROOF_ADOPTION';
const PROOF_AIAN_STATUS = 'PROOF_AIAN_STATUS';
const PROOF_BIRTH = 'PROOF_BIRTH';
const PROOF_CITIZEN_STATUS = 'PROOF_CITIZEN_STATUS';
const PROOF_CUR_ADDR = 'PROOF_CUR_ADDR';
const PROOF_DIVORCE = 'PROOF_DIVORCE';
const PROOF_EXEMPTION = 'PROOF_EXEMPTION';
const PROOF_ICHRA = 'PROOF_ICHRA';
const PROOF_INCARCERATION = 'PROOF_INCARCERATION';
const PROOF_INCOME_CHANGE = 'PROOF_INCOME_CHANGE';
const PROOF_LEGAL_PRESENCE = 'PROOF_LEGAL_PRESENCE';
const PROOF_LOST_MEDICAID = 'PROOF_LOST_MEDICAID';
const PROOF_MARRIAGE = 'PROOF_MARRIAGE';
const PROOF_PREV_ADDR = 'PROOF_PREV_ADDR';
const PROOF_PRIOR_COVERAGE = 'PROOF_PRIOR_COVERAGE';
const PROOF_OF_AIAN = 'PROOF_OF_AIAN';
const PROOF_OF_CONFIRM_CONVICTION_DISPOSITION = 'PROOF_OF_CONFIRM_CONVICTION_DISPOSITION';
const PROOF_OF_CURRENT_LEGAL_STATUS = 'PROOF_OF_CURRENT_LEGAL_STATUS';
const PROOF_OF_EMPLOYER_PLAN = 'PROOF_OF_EMPLOYER_PLAN';
const PROOF_OF_EXISTING_COVERAGE = 'PROOF_OF_EXISTING_COVERAGE';
const PROOF_OF_HRA = 'PROOF_OF_HRA';
const PROOF_OF_HRA_OFFER = 'PROOF_OF_HRA_OFFER';
const PROOF_OF_INCARCERATION_STATUS = 'PROOF_OF_INCARCERATION_STATUS';
const PROOF_OF_INCOME_CHANGE = 'PROOF_OF_INCOME_CHANGE';
const PROOF_OF_LEGAL_STATUS = 'PROOF_OF_LEGAL_STATUS';
const PROOF_OF_LOSS_OF_COVERAGE = 'PROOF_OF_LOSS_OF_COVERAGE';
const PROOF_OF_LOSS_OF_DEPENDENT = 'PROOF_OF_LOSS_OF_DEPENDENT';
const PROOF_OF_MARRIAGE = 'PROOF_OF_MARRIAGE';
const PROOF_OF_UNAAFFORDABLE_ESI = 'PROOF_OF_UNAAFFORDABLE_ESI';
const PROOF_QSEHRA = 'PROOF_QSEHRA';
const PROOF_TRIBAL_STATUS = 'PROOF_TRIBAL_STATUS';

// Document types

const ABROAD_BIRTH = 'ABROAD_BIRTH';
const ACT_2000_BIRTH = 'ACT_2000_BIRTH';
const ADMIN_CLOSURE = 'ADMIN_CLOSURE';
const ADMIN_STAY_DHS = 'ADMIN_STAY_DHS';
const ADMIN_STAY_ORDER = 'ADMIN_STAY_ORDER';
const ADOPTION_DECREE = 'ADOPTION_DECREE';
const ADOPTION_LETTER = 'ADOPTION_LETTER';
const AFFIDAVIT_MARRIAGE = 'AFFIDAVIT_MARRIAGE';
const APTC_ELIG_CONFIRM_LETTER = 'APTC_ELIG_CONFIRM_LETTER';
const ASYLUM_LETTER = 'ASYLUM_LETTER';
const AUTO_REGISTRATION = 'AUTO_REGISTRATION';
const AUTOMOBILE_REGISTRATION = 'AUTOMOBILE_REGISTRATION';
const BANK_STMT = 'BANK_STMT';
const BIA_CERTIFICATION = 'BIA_CERTIFICATION';
const BIRTH_CERT = 'BIRTH_CERT';
const BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE';
const BIRTH_CONF = 'BIRTH_CONF';
const C6_MARRIAGE = 'C6_MARRIAGE';
const CARRIER_TERM_LETTER = 'CARRIER_TERM_LETTER';
const CENSUS_REC_BIRTH = 'CENSUS_REC_BIRTH';
const CERT_CITIZENSHIP = 'CERT_CITIZENSHIP';
const CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA = 'CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA';
const CERT_OF_NATURALIZATION = 'CERT_OF_NATURALIZATION';
const CERT_OF_US_CITIZENSHIP = 'CERT_OF_US_CITIZENSHIP';
const CIRT_REPORTING_BIRTH = 'CIRT_REPORTING_BIRTH';
const COBRA_COV = 'COBRA_COV';
const COBRA_TERM = 'COBRA_TERM';
const COLLEGE_ENROLLMENT_LETTER = 'COLLEGE_ENROLLMENT_LETTER';
const CONFIRM_CONVICTION_DISP_CHARGES = 'CONFIRM_CONVICTION_DISP_CHARGES';
const CONV_DISPOSITION_LETTER = 'CONV_DISPOSITION_LETTER';
const COURT_ORDER = 'COURT_ORDER';
const COURT_ORDER_IMMIGRATION = 'COURT_ORDER_IMMIGRATION';
const COURT_ORDER_INDICATING_ADD_REMOVE = 'COURT_ORDER_INDICATING_ADD_REMOVE';
const COURT_ORDER_PETITION_NAME_CHANGE = 'COURT_ORDER_PETITION_NAME_CHANGE';
const CTZN_ID_CARD = 'CTZN_ID_CARD';
const CUR_VISA_STATUS = 'CUR_VISA_STATUS';
const COVERAGE_EXHAUSTION_LETTER = 'COVERAGE_EXHAUSTION_LETTER';
const DEATH_CERTIFICATE = 'DEATH_CERTIFICATE';
const DEDUCTION_PAYSTUB = 'DEDUCTION_PAYSTUB';
const DENIAL_LETTER_FROM_YOUR_STATE = 'DENIAL_LETTER_FROM_YOUR_STATE';
const DIVORCE_DECREE = 'DIVORCE_DECREE';
const DOC_INDICATING_LEGAL_STATUS = 'DOC_INDICATING_LEGAL_STATUS';
const DOC_REFUGEE_SETTLEMENT = 'DOC_REFUGEE_SETTLEMENT';
const DOC_SUPPORTING_EVENT = 'DOC_SUPPORTING_EVENT';
const DOC_WITHHOLD_REMOVAL = 'DOC_WITHHOLD_REMOVAL';
const DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH';
const DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION = 'DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION';
const DOMESTIC_LEGAL_DOCUMENT = 'DOMESTIC_LEGAL_DOCUMENT';
const DOMESTIC_PARTNER_CERT = 'DOMESTIC_PARTNER_CERT';
const DS2019 = 'DS2019';
const DRIVER_LICENSE = 'DRIVER_LICENSE';
const DRIVERS_LIC = 'DRIVERS_LIC';
const EARNINGS_STATEMENT = 'EARNINGS_STATEMENT';
const EMPLYR_CONTRI_TERM_FRM_COBRA = 'EMPLYR_CONTRI_TERM_FRM_COBRA';
const EMPLYR_CONTRI_TERM_FRM_EMPLYR = 'EMPLYR_CONTRI_TERM_FRM_EMPLYR';
const EMPLYR_COVERAGE_OFFER = 'EMPLYR_COVERAGE_OFFER';
const ESC_EMPLOYER_PLAN_DETAILS = 'ESC_EMPLOYER_PLAN_DETAILS';
const EXEMPTION_LETTER = 'EXEMPTION_LETTER';
const EXHAUSTION_OF_COBRA_BENEFITS = 'EXHAUSTION_OF_COBRA_BENEFITS';
const FUND_EXHAUSTION_FM_PERSI = 'FUND_EXHAUSTION_FM_PERSI';
const FOREIGN_ADOPTION_LETTER = 'FOREIGN_ADOPTION_LETTER';
const FOREIGN_BIRTH_RECORD = 'FOREIGN_BIRTH_RECORD';
const FORM_1040 = 'FORM_1040';
const FORM_1040_SE = 'FORM_1040_SE';
const FORM_1065 = 'FORM_1065';
const FOSTER_CARE_LETTER = 'FOSTER_CARE_LETTER';
const GOV_ADOPTION_LETTER = 'GOV_ADOPTION_LETTER';
const GOV_LETTER_GOV = 'GOV_LETTER_GOV';
const GOV_LETTERHEAD = 'GOV_LETTERHEAD';
const GOV_TERM_LETTER = 'GOV_TERM_LETTER';
const GOVT_LETTER_ADDR = 'GOVT_LETTER_ADDR';
const HEALTH_CARE_PROGRAM_DOCUMENT = 'HEALTH_CARE_PROGRAM_DOCUMENT';
const HEALTH_INSURANCE_PROOF = 'HEALTH_INSURANCE_PROOF';
const HOME_PAYMENT = 'HOME_PAYMENT';
const HOME_PAYMENT_NOTICE = 'HOME_PAYMENT_NOTICE';
const HOME_PURCHASE_AGREEMENT = 'HOME_PURCHASE_AGREEMENT';
const HOSPITAL_RECORD = 'HOSPITAL_RECORD';
const HRA_EMPLOYER_NOTICE = 'HRA_EMPLOYER_NOTICE';
const HRA_OFFER_DOCUMENT = 'HRA_OFFER_DOCUMENT';
const I20 = 'I20';
const I94 = 'I94';
const I94_UNEXP = 'I94_UNEXP';
const I130 = 'I130';
const I327 = 'I327';
const I360 = 'I360';
const I551 = 'I551';
const I571 = 'I571';
const I688 = 'I688';
const I688A = 'I688A';
const I688B = 'I688B';
const I766 = 'I766';
const I797_APPROVAL = 'I797_APPROVAL';
const ICE_LETTER = 'ICE_LETTER';
const ICE_STATUS_LETTER = 'ICE_STATUS_LETTER';
const ICHRA_LETTER = 'ICHRA_LETTER';
const IMMIGRATION_CONF = 'IMMIGRATION_CONF';
const INCOME_1040 = '1040_INCOME';
const INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE = 'INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE';
const INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE = 'INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE';
const INCREASE_IN_SUBSIDY_INCOME_CHANGE = 'INCREASE_IN_SUBSIDY_INCOME_CHANGE';
const INSURANCE_LETTER_ADDR = 'INSURANCE_LETTER_ADDR';
const INSURANCE_LETTER_COV = 'INSURANCE_LETTER_COV';
const LEGAL_GUARDIANSHIP_LETTER = 'LEGAL_GUARDIANSHIP_LETTER';
const LEGAL_SEPARATION_DOC = 'LEGAL_SEPARATION_DOC';
const LETTER_ABOUT_COBRA_COVERAGE = 'LETTER_ABOUT_COBRA_COVERAGE';
const LETTER_FOR_LOSS_OF_STUDENT_COVERAGE = 'LETTER_FOR_LOSS_OF_STUDENT_COVERAGE';
const LETTER_FROM_A_GOVERNMENT_ORGANIZATION = 'LETTER_FROM_A_GOVERNMENT_ORGANIZATION';
const LETTER_FROM_AN_EMPLOYER = 'LETTER_FROM_AN_EMPLOYER';
const LETTER_OF_EXPLANATION = 'LETTER_OF_EXPLANATION';
const LETTER_STATING_LOST_COVERAGE = 'LETTER_STATING_LOST_COVERAGE';
const MARINAS_ID_CARD = 'MARINAS_ID_CARD';
const MARKETPLACE_COV = 'MARKETPLACE_COV';
const MARKETPLACE_LETTER = 'MARKETPLACE_LETTER';
const MARRIAGE_AFFIDAVIT = 'MARRIAGE_AFFIDAVIT';
const MARRIAGE_LETTER = 'MARRIAGE_LETTER';
const MARRIAGE_CERTIFICATE = 'MARRIAGE_CERTIFICATE';
const MEDICAID_LETTER = 'MEDICAID_LETTER';
const MEDICAL_CONDITIONS = 'MEDICAL_CONDITIONS';
const MEDICAL_RECORD = 'MEDICAL_RECORD';
const MEDICAL_RECORDS_BIRTH = 'MEDICAL_RECORDS_BIRTH';
const MEDICAL_SUPPORT_ORDER = 'MEDICAL_SUPPORT_ORDER';
const MILITARY_BIRTH_RECORD = 'MILITARY_BIRTH_RECORD';
const MIL_RECORD_BIRTH = 'MIL_RECORD_BIRTH';
const MORTGAGE_DOCUMENT = 'MORTGAGE_DOCUMENT';
const MOVED_INTO_THE_US = 'MOVED_INTO_THE_US';
const N550 = 'N550';
const NOTICE_OF_HEARING = 'NOTICE_OF_HEARING';
const OBITUARY = 'OBITUARY';
const OFFER_OF_EMPLOYMENT = 'OFFER_OF_EMPLOYMENT';
const ORDER_OF_SUPERVISION = 'ORDER_OF_SUPERVISION';
const ORR_LETTER = 'ORR_LETTER';
const OTHER = 'OTHER';
const OTHER_EXCEPTIONS = 'OTHER_EXCEPTIONS';
const PASS_CARD = 'PASS_CARD';
const PASSPORT_CARD = 'PASSPORT_CARD';
const PAY_STUB_COV = 'PAY_STUB_COV';
const PAY_STUB_INCOME = 'PAY_STUB_INCOME';
const PAY_STUBS = 'PAY_STUBS';
const PAYCHECK = 'PAYCHECK';
const PBLC_RCRD_MARRIAGE = 'PBLC_RCRD_MARRIAGE';
const PEBPS_LETTER = 'PEBPS_LETTER';
const POSTAL_ADDRESS_LETTER = 'POSTAL_ADDRESS_LETTER';
const PREV_EMPL_LETTER = 'PREV_EMPL_LETTER';
const PRIOR_EMPLYR_LOSS_OF_COVERAGE = 'PRIOR_EMPLYR_LOSS_OF_COVERAGE';
const PROFIT_LOSS_STMT = 'PROFIT_LOSS_STMT';
const PROOF_OF_EXISTING_ESC = 'PROOF_OF_EXISTING_ESC';
const PROOF_OF_INCOME = 'PROOF_OF_INCOME';
const PROOF_OF_STAY = 'PROOF_OF_STAY';
const PROPERTY_TAX = 'PROPERTY_TAX';
const PROPERTY_TAX_NOTICE = 'PROPERTY_TAX_NOTICE';
const QSEHRA_LETTER = 'QSEHRA_LETTER';
const REAL_ID = 'REAL_ID';
const REF_LETTER_ADDR = 'REF_LETTER_ADDR';
const RELIGIOUS_BIRTH_RECORD = 'RELIGIOUS_BIRTH_RECORD';
const RELIGIOUS_MARRIAGE_LETTER = 'RELIGIOUS_MARRIAGE_LETTER';
const RELEGIOUS_REC_BIRTH = 'RELEGIOUS_REC_BIRTH';
const REMOVAL_CANCELLATION = 'REMOVAL_CANCELLATION';
const RENTAL_AGREEMENT = 'RENTAL_AGREEMENT';
const REPORT_TO_MILITARY_DUTY = 'REPORT_TO_MILITARY_DUTY';
const RESIDENT_ALIEN_CARD = 'RESIDENT_ALIEN_CARD';
const SCHOOL_REC_BIRTH = 'SCHOOL_REC_BIRTH';
const SCREENSHOT_OF_RESULTS = 'SCREENSHOT_OF_RESULTS';
const SELF_EMP_INCOME = 'SELF_EMP_INCOME';
const SELF_EMPL_LETTER = 'SELF_EMPL_LETTER';
const SIGNED_AFFIDAVIT = 'SIGNED_AFFIDAVIT';
const SPECIAL_CIRCUMSTANCE_ATTESTATION = 'SPECIAL_CIRCUMSTANCE_ATTESTATION';
const SSA_INCOME = 'SSA_INCOME';
const STAR_CARD = 'STAR_CARD';
const STATE_ID = 'STATE_ID';
const STATE_ISSUED_ID = 'STATE_ISSUED_ID';
const STUDENT_HEALTH_COV = 'STUDENT_HEALTH_COV';
const STUDENT_LETTER_COV = 'STUDENT_LETTER_COV';
const T_I551 = 'T_I551';
const TAX_RETURN = 'TAX_RETURN';
const TECHNICAL_ISSUE = 'TECHNICAL_ISSUE';
const TERM_LETTER = 'TERM_LETTER';
const TEMP_I551_STAMP = 'TEMP_I551_STAMP';
const TERM_LETTER_FROM_CARRIER = 'TERM_LETTER_FROM_CARRIER';
const TERM_LETTER_FROM_GOV_PROVIDER = 'TERM_LETTER_FROM_GOV_PROVIDER';
const TIME_SERVED_LETTER = 'TIME_SERVED_LETTER';
const TRIBAL_BIRTH = 'TRIBAL_BIRTH';
const TRIBAL_DOCUMENT = 'TRIBAL_DOCUMENT';
const TRIBAL_MEMBERSHIP = 'TRIBAL_MEMBERSHIP';
const UNEMPLOYMENT_LETTER = 'UNEMPLOYMENT_LETTER';
const UNEMP_INCOME = 'UNEMP_INCOME';
const UNEXP_PASSPORT = 'UNEXP_PASSPORT';
const US_BIRTH_CERT = 'US_BIRTH_CERT';
const US_BIRTH_CERTIFICATE = 'US_BIRTH_CERTIFICATE';
const US_CIVIL_SERVICES_BIRTH = 'US_CIVIL_SERVICES_BIRTH';
const US_PASSPORT = 'US_PASSPORT';
const US_POSTAL_LETTER = 'US_POSTAL_LETTER';
const USCIS_LETTER = 'USCIS_LETTER';
const UTIL_BILLS = 'UTIL_BILLS';
const UTILITY_BILLS = 'UTILITY_BILLS';
const VALIDATION_ON_ID_REPOSITORY = 'VALIDATION_ON_ID_REPOSITORY';
const VERIFICATION_OF_TIME_SERVED = 'VERIFICATION_OF_TIME_SERVED';
const VOTER_CARD = 'VOTER_CARD';
const W2_INCOME = 'W2_INCOME';
const WAGES = 'WAGES';
const WITHHOLDING_LETTER = 'WITHHOLDING_LETTER';

export const TYPES_EXCEPTIONS_FOR_LABELS = {
    SPECIAL_CIRCUMSTANCE_ATTESTATION,
};

const DOCUMENT_CONFIGS = {
    INCOME_1040,
    ABROAD_BIRTH,
    ACT_2000_BIRTH,
    ADD_DEPENDENT,
    ADD_DEPENDENTS,
    ADDRESS_PROOF,
    ADMIN_CLOSURE,
    ADMIN_STAY_DHS,
    ADMIN_STAY_ORDER,
    ADOPTION,
    ADOPTION_LETTER,
    ADOPTION_DECREE,
    AFFIDAVIT_MARRIAGE,
    APTC_ELIG_CONFIRM_LETTER,
    ASYLUM_LETTER,
    AUTO_REGISTRATION,
    AUTOMOBILE_REGISTRATION,
    BANK_STMT,
    BIA_CERTIFICATION,
    BIRTH,
    BIRTH_ADOPTION,
    BIRTH_OR_ADOPTION,
    BIRTH_CERT,
    BIRTH_CERTIFICATE,
    BIRTH_CONF,
    C6_MARRIAGE,
    CARRIER_TERM_LETTER,
    CENSUS_REC_BIRTH,
    CERT_CITIZENSHIP,
    CERT_INDIAN_ALASKAN_BLOOD_FROM_BIA,
    CERT_OF_NATURALIZATION,
    CERT_OF_US_CITIZENSHIP,
    CHANGE_IN_ADDRESS,
    CHANGE_IN_ADDRESS_FUTURE,
    CHANGE_IN_ADDRESS_WITHIN_STATE,
    CHANGE_IN_AI_AN_STATUS,
    CHANGE_IN_CITIZENSHIP,
    CHANGE_IN_HOUSEHOLD_SIZE,
    CHANGE_IN_INCARCERATION,
    CHANGE_IN_INCOME,
    CHANGE_IN_LEGAL_PRESENCE,
    CHANGE_IN_TRIBE_STATUS,
    CHILD_AGED_OUT_FROM_OLD_APPLICATION,
    CIRT_REPORTING_BIRTH,
    COBRA_COV,
    COBRA_TERM,
    COLLEGE_ENROLLMENT_LETTER,
    CONFIRM_CONVICTION_DISP_CHARGES,
    CONV_DISPOSITION_LETTER,
    COURT_ORDER,
    COURT_ORDER_IMMIGRATION,
    COURT_ORDER_INDICATING_ADD_REMOVE,
    COURT_ORDER_PETITION_NAME_CHANGE,
    COVERAGE_EXHAUSTION_LETTER,
    CTZN_ID_CARD,
    CUR_VISA_STATUS,
    CURRENT_ADDRESS_PROOF,
    DEATH,
    DEATH_CERTIFICATE,
    DEATH_OF_PTF_OR_SUBSCRIBER,
    DEDUCTION_PAYSTUB,
    DENIAL_LETTER_FROM_YOUR_STATE,
    DIVORCE,
    DIVORCE_DECREE,
    DIVORCE_OR_ANULLMENT,
    DOC_INDICATING_EXCEPTIONS,
    DOC_INDICATING_LEGAL_STATUS,
    DOC_INDICATING_PROOF_OF_DEATH,
    DOC_INDICATING_ADD_REMOVE_OF_DEP,
    DOC_PROVING_EVENT,
    DOC_REFUGEE_SETTLEMENT,
    DOC_SUPPORTING_EVENT,
    DOC_WITHHOLD_REMOVAL,
    DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DEATH,
    DOCUMENT_FOR_COVERAGE_LOSS_DUE_TO_DIVORCE_SEPARATION,
    DOMESTIC_LEGAL_DOCUMENT,
    DOMESTIC_PARTNER_CERT,
    DRIVER_LICENSE,
    DRIVERS_LIC,
    DS2019,
    EARNINGS_STATEMENT,
    EMPLOYER_SPONSORED_COVERAGE_AFFORDABLE,
    EMPLOYER_SPONSORED_COVERAGE_UNAFFORDABLE,
    EMPLYR_CONTRI_TERM_FRM_COBRA,
    EMPLYR_CONTRI_TERM_FRM_EMPLYR,
    EMPLYR_COVERAGE_OFFER,
    ERROR_ASSISTER_BROKER,
    ERROR_DUE_TO_ASSISTER_OR_BROKER,
    ERROR_DUE_TO_EXCHANGE,
    ERROR_EXCHANGE,
    ERROR_HEALTH_PLAN_VIOLATION,
    ERROR_PLAN_BENEFIT_DISPLAY,
    ERROR_PLAN_OR_BENEFIT_DISPLAY,
    ESC_EMPLOYER_PLAN_DETAILS,
    EXCEPTIONAL_CIRCUMSTANCES_INDIVIDUAL,
    EXCEPTIONAL_CIRCUMSTANCES_NATURAL_DISASTER,
    EXCEPTIONAL_CIRCUMSTANCES_OR_PLAN_PROGRAM_ERROR,
    EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_BACKLOG,
    EXCEPTIONAL_CIRCUMSTANCES_SYSTEM_ERROR,
    EXCHANGE_CONFIRMATION_OF_APTC,
    EXEMPTION_CANCELLED,
    EXEMPTION_LETTER,
    EXHAUSTION_OF_COBRA_BENEFITS,
    FOREIGN_ADOPTION_LETTER,
    FOREIGN_BIRTH_RECORD,
    FORM_1040,
    FORM_1040_SE,
    FORM_1065,
    FOSTER_CARE_LETTER,
    FUND_EXHAUSTION_FM_PERSI,
    FUTURE_LOSS_OF_MEC,
    GAIN_CITIZENSHIP,
    GAIN_COURT_APPOINTED_DEPENDENT,
    GAIN_IN_TRIBE_STATUS,
    GAIN_LPR,
    GAIN_OF_AI_AN,
    GAIN_OF_AMERICAN_INDIAN_STATUS,
    GOV_ADOPTION_LETTER,
    GOV_LETTER_GOV,
    GOV_LETTERHEAD,
    GOV_TERM_LETTER,
    GOVT_LETTER_ADDR,
    HEALTH_CARE_PROGRAM_DOCUMENT,
    HEALTH_INSURANCE_PROOF,
    HOME_PAYMENT,
    HOME_PAYMENT_NOTICE,
    HOME_PURCHASE_AGREEMENT,
    HOSPITAL_RECORD,
    HRA,
    HRA_EMPLOYER_NOTICE,
    HRA_FUTURE,
    HRA_OFFER_DOCUMENT,
    I20,
    I327,
    I360,
    I551,
    I571,
    I688,
    I688A,
    I688B,
    I766,
    I797_APPROVAL,
    I94,
    I94_UNEXP,
    I130,
    ICE_LETTER,
    ICE_STATUS_LETTER,
    ICHRA_LETTER,
    ICHRA_SEP,
    ICHRA_SEP_FUTURE,
    IDENTIFICATION,
    IMMIGRATION_CONF,
    INCOME_CHANGE_CSR,
    INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE,
    INCREASE_IN_SUBSIDY_EMPLOYER_PLAN_CHANGE_FUTURE,
    INCREASE_IN_SUBSIDY_INCOME_CHANGE,
    INCARCERATION,
    INSURANCE_LETTER_ADDR,
    INSURANCE_LETTER_COV,
    LEGAL_GUARDIANSHIP_LETTER,
    LEGAL_SEPARATION,
    LETTER_ABOUT_COBRA_COVERAGE,
    LETTER_FOR_LOSS_OF_STUDENT_COVERAGE,
    LETTER_FROM_A_GOVERNMENT_ORGANIZATION,
    LETTER_FROM_AN_EMPLOYER,
    LETTER_OF_EXPLANATION,
    LETTER_STATING_LOST_COVERAGE,
    LEGAL_SEPARATION_DOC,
    LOSE_COVERAGE_NON_PAYMENT,
    LOSE_COVERAGE_NON_PAYMENT_TYPE4,
    LOSE_EMPLOYER_COVERAGE,
    LOSE_EMPLOYER_COVERAGE_TYPE4,
    LOSE_OTHER_PUBLIC_MEC,
    LOSE_OTHER_PUBLIC_MEC_TYPE4,
    LOSS_OF_AIAN,
    LOSS_OF_COVERAGE_THROUGH_EMPLOYER,
    LOSS_OF_COVERAGE_THROUGH_EMPLOYER_FUTURE,
    LOSS_OF_MEDICAID,
    LOSS_OF_MEDICAID_FUTURE,
    LOSS_OF_MEC,
    LOSS_OF_MEC_FUTURE,
    LOST_OTHER_MIN_ESSENTIAL_COVERAGE,
    LOST_OTHER_MIN_ESSENTIAL_COVERAGE_FUTURE,
    MARRIAGE,
    MARRIAGE_AFFIDAVIT,
    MARRIAGE_CERTIFICATE,
    MARRIAGE_LETTER,
    MARINAS_ID_CARD,
    MARKETPLACE_COV,
    MARKETPLACE_LETTER,
    MEDICAID_LETTER,
    MEDICAL_CONDITIONS,
    MEDICAL_RECORD,
    MEDICAL_RECORDS_BIRTH,
    MEDICAL_SUPPORT_ORDER,
    MILITARY_BIRTH_RECORD,
    MIL_RECORD_BIRTH,
    MORTGAGE_DOCUMENT,
    MOVED_INTO_STATE,
    MOVED_INTO_STATE_FUTURE,
    MOVED_INTO_THE_US,
    NEWLY_ELIG_FOR_APTC,
    N550,
    NOT_INCARCERATED,
    NOTICE_OF_HEARING,
    OBITUARY,
    OFFER_OF_EMPLOYMENT,
    ORDER_OF_SUPERVISION,
    ORR_LETTER,
    OTHER,
    OTHER_EXCEPTIONAL_CIRCUMSTANCES,
    OTHER_EXCEPTIONS,
    PASS_CARD,
    PASSPORT_CARD,
    PAY_STUBS,
    PAY_STUB_COV,
    PAY_STUB_INCOME,
    PAYCHECK,
    PBLC_RCRD_MARRIAGE,
    PEBPS_LETTER,
    PREV_EMPL_LETTER,
    POSTAL_ADDRESS_LETTER,
    PRIOR_EMPLYR_LOSS_OF_COVERAGE,
    PRIMARY_GAIN_OF_MEC,
    PRIMARY_GAIN_OF_MEC_FUTURE,
    PROFIT_LOSS_STMT,
    PROOF_ADOPTION,
    PROOF_AIAN_STATUS,
    PROOF_BIRTH,
    PROOF_CITIZEN_STATUS,
    PROOF_CUR_ADDR,
    PROOF_DIVORCE,
    PROOF_EXEMPTION,
    PROOF_ICHRA,
    PROOF_INCARCERATION,
    PROOF_INCOME_CHANGE,
    PROOF_LEGAL_PRESENCE,
    PROOF_LOST_MEDICAID,
    PROOF_MARRIAGE,
    PROOF_PREV_ADDR,
    PROOF_PRIOR_COVERAGE,
    PROOF_OF_AIAN,
    PROOF_OF_CONFIRM_CONVICTION_DISPOSITION,
    PROOF_OF_CURRENT_LEGAL_STATUS,
    PROOF_OF_EMPLOYER_PLAN,
    PROOF_OF_EXISTING_COVERAGE,
    PROOF_OF_EXISTING_ESC,
    PROOF_OF_HRA,
    PROOF_OF_HRA_OFFER,
    PROOF_OF_INCARCERATION_STATUS,
    PROOF_OF_INCOME,
    PROOF_OF_INCOME_CHANGE,
    PROOF_OF_LEGAL_STATUS,
    PROOF_OF_LOSS_OF_COVERAGE,
    PROOF_OF_LOSS_OF_DEPENDENT,
    PROOF_OF_MARRIAGE,
    PROOF_OF_STAY,
    PROOF_OF_UNAAFFORDABLE_ESI,
    PROOF_QSEHRA,
    PROOF_TRIBAL_STATUS,
    PROPERTY_TAX,
    PROPERTY_TAX_NOTICE,
    QSEHRA_LETTER,
    QSEHRA_SEP,
    QSEHRA_SEP_FUTURE,
    REAL_ID,
    REF_LETTER_ADDR,
    RELIGIOUS_BIRTH_RECORD,
    RELIGIOUS_MARRIAGE_LETTER,
    RELEGIOUS_REC_BIRTH,
    REMOVAL_CANCELLATION,
    RENTAL_AGREEMENT,
    REMOVE_DEPENDENT,
    REPORT_TO_MILITARY_DUTY,
    RESIDENT_ALIEN_CARD,
    SCHOOL_REC_BIRTH,
    SCREENSHOT_OF_RESULTS,
    SELF_EMP_INCOME,
    SELF_EMPL_LETTER,
    SIGNED_AFFIDAVIT,
    SPECIAL_CIRCUMSTANCE_ATTESTATION,
    SSA_INCOME,
    STAR_CARD,
    STATE_ID,
    STATE_ISSUED_ID,
    STUDENT_HEALTH_COV,
    STUDENT_LETTER_COV,
    SURVIVOR_OF_DOMESTIC_ABUSE_OR_SPOUSAL_ABANDONMENT,
    T_I551,
    TAX_RETURN,
    TECHNICAL_ISSUE,
    TEMP_I551_STAMP,
    TERM_LETTER,
    TERM_LETTER_FROM_CARRIER,
    TERM_LETTER_FROM_GOV_PROVIDER,
    TIME_SERVED_LETTER,
    TRIBAL_BIRTH,
    TRIBAL_DOCUMENT,
    TRIBAL_MEMBERSHIP,
    UNEMPLOYMENT_LETTER,
    UNEMP_INCOME,
    UNEXP_PASSPORT,
    UNSUPPORTED_EVENT,
    US_BIRTH_CERT,
    US_BIRTH_CERTIFICATE,
    US_CIVIL_SERVICES_BIRTH,
    US_PASSPORT,
    US_POSTAL_LETTER,
    USCIS_LETTER,
    UTIL_BILLS,
    UTILITY_BILLS,
    VALIDATION_ON_ID_REPOSITORY,
    VERIFICATION_OF_TIME_SERVED,
    VOTER_CARD,
    W2_INCOME,
    WAGES,
    WITHHOLDING_LETTER
};

export default DOCUMENT_CONFIGS;
